import "./App.css";
import { Route, Routes } from "react-router";
import SignInPage from "./containers/SignInPage/SignInPage";
import Navbar from "./components/Navbar/Navbar";
import SignUpPage from "@containers/SignUpPage/SignUpPage";
import ManagePage from "@containers/ManagePage/ManagePage";
import ForgotPasswordPage from "@containers/ForgotPasswordPage/ForgotPasswordPage";
import ManageDoctorPage from "@containers/ManageDoctorPage/ManageDocotorPage";
import ManagePatientPage from "@containers/ManagePatientPage/ManagePatientPage";
import DoctorDetailPage from "@containers/DoctorDetailPage/DoctorDetailPage";
import { Toaster } from "react-hot-toast";
import ProtectedRoute from "@components/PrivateRoute/ProtectedRoute";
import { setRetrieveTokenSucess } from "@redux/slices/authenticationSlice";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import useIndexedDB from "@hooks/useIndexedDB";
import PatientDetailPage from "@containers/PatientDetailPage/PatientDetailPage";
import PopUpCenter from "@components/PopUpCenter";
import ManagePricePage from "@containers/ManagePricePage/ManagePricePage";
import PriceCreatePage from "@containers/PriceCreatePage/PriceCreatePage";
import PriceDetailPage from "@containers/PriceDetailPage/PriceDetailPage";
import ManagePostPayPage from "@containers/ManagePostPayPage/ManagePostPayPage";
import UpgradeAccessPage from "@containers/UpgradeAccessPage/UpgradeAccessPage";
import ViewHistoryPage from "@containers/ViewHistoryPage/ViewHistoryPage";
import ViewUserPage from "@containers/ViewUserPage/ViewUserPage";
import TicketSupport from "@containers/TicketSupportPage/TicketSupportPage";
import ViewProgressPage from "@containers/ViewProgressPage/ViewProgressPage";
import ViewTicketPage from "@containers/ViewTicket/ViewTicketPage";

function App() {
  const dispatch = useDispatch();
  const componentToShow = useSelector((state) => state.popup.component);
  const popUpCenterState = useSelector((state) => state.popup.isOpen);
  const { retrieveToken } = useIndexedDB();
  const { authToken } = useSelector((state) => state.auth);

  const handleRetrieveToken = async () => {
    const token = await retrieveToken();
    if (token) {
      dispatch(setRetrieveTokenSucess(token));
    }
  };

  useEffect(() => {
    handleRetrieveToken();
  }, []);

  return (
    <>
      {authToken ? <Navbar /> : null}
      <PopUpCenter ContentComp={componentToShow} isOpen={popUpCenterState} />
      <Routes>
        <Route path="/signin" element={<SignInPage />} />
        <Route path="/signup" element={<SignUpPage />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <ManagePage />
            </ProtectedRoute>
          }
        />
        <Route path="/forgotpassword" element={<ForgotPasswordPage />} />
        <Route
          path="/managedoctor"
          element={
            <ProtectedRoute>
              <ManageDoctorPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/managepatient"
          element={
            <ProtectedRoute>
              <ManagePatientPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/manageprice"
          element={
            <ProtectedRoute>
              <ManagePricePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/manageprice/add"
          element={
            <ProtectedRoute>
              <PriceCreatePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/doctor/:email"
          element={
            <ProtectedRoute>
              <DoctorDetailPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/patient/:email"
          element={
            <ProtectedRoute>
              <PatientDetailPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/manageprice/:myReferenceNumber"
          element={
            <ProtectedRoute>
              <PriceDetailPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/managepostpay"
          element={
            <ProtectedRoute>
              <ManagePostPayPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/managepostpay/upgradeaccess"
          element={
            <ProtectedRoute>
              <UpgradeAccessPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/managepostpay/postpayhistory"
          element={
            <ProtectedRoute>
              <ViewHistoryPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/managepostpay/viewuser/:myReferenceNumber"
          element={
            <ProtectedRoute>
              <ViewUserPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/ticketsupport"
          element={
            <ProtectedRoute>
              <TicketSupport />
            </ProtectedRoute>
          }
        />
        <Route
          path="/ticketsupport/viewprogress"
          element={
            <ProtectedRoute>
              <ViewProgressPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/ticketsupport/viewticket"
          element={
            <ProtectedRoute>
              <ViewTicketPage />
            </ProtectedRoute>
          }
        />
      </Routes>
      <Toaster />
    </>
  );
}

export default App;
